export async function fetchJson({
    url,
    method = 'GET',
    params = undefined,
    signal
}) {
    if (params !== undefined) {
        // Add params to the url
        params = new URLSearchParams(params)

        url = `${url}?${params}`
    }

    let headers = {
        Accept: "application/json"
    }

    if (
        Object(window.Laravel)
            .hasOwnProperty('api_token')
    ) {
        headers['Authorization'] = `Bearer ${window.Laravel.api_token}`;
    }

    return await fetch(url, {
        method,
        credentials: "include", // include, *same-origin, omit
        headers,
        signal
    })
}

/** Default URL for CSRF token refresh when retryOnCsrfExpiry is true. Single route used by all opted-in forms. */
const CSRF_REFRESH_DEFAULT_URL = '/csrf-refresh'

async function getNewCsrfToken(refreshUrl) {
    const r = await fetch(refreshUrl, { credentials: 'include' })
    if (!r.ok) throw new Error('CSRF refresh failed')
    const { csrf_token: newToken } = await r.json()
    if (window.Laravel) window.Laravel.csrf_token = newToken
    return newToken
}

export async function fetchPost({
    url,
    body = {},
    method = 'POST',
    signal = undefined,
    csrfToken = undefined,
    retryOnCsrfExpiry = false,
    csrfRefreshUrl = CSRF_REFRESH_DEFAULT_URL,
    maxCsrfRetries = 3
}) {
    let isFormData = body instanceof FormData
    const token = csrfToken ?? window.Laravel?.csrf_token

    let headers = {
        "X-CSRF-TOKEN": token,
        Accept: "application/json",
    }

    if (
        Object(window.Laravel)
            .hasOwnProperty('api_token')
    ) {
        headers['Authorization'] = `Bearer ${window.Laravel.api_token}`;
    }

    if (! isFormData) {
        headers['Content-Type'] = 'application/json'
    }

    let fetchParameter = {
        method,
        body: isFormData
            ? body
            : JSON.stringify(body),
        credentials: "include", // include, *same-origin, omit
        headers
    }

    if (signal !== undefined) {
        fetchParameter['signal'] = signal
    }

    let response = await fetch(url, fetchParameter)

    if (response.status === 419 && retryOnCsrfExpiry && csrfRefreshUrl && maxCsrfRetries > 0) {
        const newToken = await getNewCsrfToken(csrfRefreshUrl)

        return fetchPost({
            url,
            body,
            method,
            signal,
            csrfToken: newToken,
            retryOnCsrfExpiry: true,
            csrfRefreshUrl,
            maxCsrfRetries: maxCsrfRetries - 1
        })
    }

    return response
}
